import { render } from "./TopPurchaser.vue?vue&type=template&id=4e2e13b4"
import script from "./TopPurchaser.vue?vue&type=script&lang=js"
export * from "./TopPurchaser.vue?vue&type=script&lang=js"

import "./TopPurchaser.vue?vue&type=style&index=0&id=4e2e13b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/TopPurchaser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e2e13b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e2e13b4', __exports__)) {
    api.reload('4e2e13b4', __exports__)
  }
  
  module.hot.accept("./TopPurchaser.vue?vue&type=template&id=4e2e13b4", () => {
    api.rerender('4e2e13b4', render)
  })

}


export default __exports__